import { FeaturesCard, HowItWorksItem, Faq } from 'sections/Benefits/MemberDirectory/types';

export const howItWorksItems: HowItWorksItem[] = [
  {
    id: 1,
    title: 'Search by Service or Location',
    description: 'Need help with cold chain shipping in Southeast Asia? Or maybe customs clearance in Europe? Filter accordingly.',
    iconName: 'icon-file-magnifying-glass.svg',
    svgName: 'dotted-line-desktop.svg',
    svgNameMobile: 'dotted-line-mobile.svg',
  },
  {
    id: 2,
    title: 'Explore Profiles',
    description: 'Dig into the details. Click on the company manager\'s profile to learn more about the company\'s registered address, work experience, service specialization and service region.',
    iconName: 'icon-invoice.svg',
    svgName: 'dotted-line-desktop.svg',
    svgNameMobile: 'dotted-line-mobile.svg',
  },
  {
    id: 3,
    title: 'Connect Directly',
    description: 'No middlemen. Use the platform to find direct contacts and send an email or phone request.',
    iconName: 'icon-pull-request.svg',
    svgName: 'dotted-line-desktop.svg',
    svgNameMobile: 'dotted-line-mobile.svg',
  },
  {
    id: 4,
    title: 'Build Confidence and Ship',
    description: 'The goal isn’t just finding someone who can ship it’s finding someone who can grow with you. That starts with the first conversation.',
    iconName: 'icon-chart-line-up.svg',
  },
];

export const featuresCards: FeaturesCard[] = [
  {
    id: 1,
    icon: 'icon-badge-check.svg',
    title: 'Vetted Partners',
    description: 'No more crossing fingers. Every listing goes through a screening process, so you\'re dealing with people who’ve earned their spot.',
    alt: 'Vetted partners',
  },
  {
    id: 2,
    icon: 'icon-pen.svg',
    title: 'Smart Filters',
    description: 'Quickly zero in on forwarders by region, service type, or specialization. It saves time and spares you the spreadsheets.',
    alt: 'Smart filters',
  },
  {
    id: 3,
    icon: 'icon-globe.svg',
    title: 'Global Coverage',
    description: 'From local hauls to intercontinental shipments, the network spans more than 150 countries. Your next partner could be a few clicks away.',
    alt: 'Global Coverage',
  },
  {
    id: 4,
    icon: 'icon-code-fork.svg',
    title: 'Built for Collaboration',
    description: 'It’s not just a directory it’s a space for relationship-building. Reach out, align goals, and set the groundwork for long-term cooperation.',
    alt: 'Built for Collaboration',
  },
  {
    id: 5,
    icon: 'icon-badge-check.svg',
    title: 'Real-Time Profiles',
    description: 'You’re not stuck with vague summaries. Each profile comes with service details, contact info, and even insights from other users.',
    alt: 'Real-Time Profiles',
  },
  {
    id: 6,
    icon: 'icon-pen.svg',
    title: 'Perks for DFA Members',
    description: 'Even free-tier members get benefits. From platform access to communication tools, you’re already ahead just by joining.',
    alt: 'Perks for DFA Members',
  },
];

export const faq: Faq[] = [
  {
    id: "1",
    question: "What are the benefits of DF Alliance’s Member Directory?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          The biggest advantage is peace of mind. You’re choosing from a trusted pool, with tools that simplify partner discovery and outreach.
        </p>
      `
    ),
  },
  {
    id: "2",
    question: "How do I find a freight forwarder in a specific region?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Use the regional filters down to the country or even city level. You’ll see listings only in the areas that matter to your routes.
        </p>
      `
    ),
  },
  {
    id: "3",
    question: "What’s the difference between a freight broker and a freight forwarder?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          A broker connects the dots. A forwarder moves the goods and manages logistics. The latter is typically more hands-on and service-driven.
        </p>
      `
    ),
  },
  {
    id: "4",
    question: "Does this website list freight forwarding companies?",
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Yes. Only verified freight forwarders who meet DF Alliance standards are listed here.
        </p>
      `
    ),
  },
];